"use strict";

var _constants = require("../../../constants");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = currentItemProgress;

function currentItemProgress(items) {
  if (!items || !items.length) return 0;
  var firstItemInProgress = items.filter(function (item) {
    return item.loaded && 0 < item.loaded && item.uploadStatus !== _constants.ITEM_STATUS.ERROR && item.uploadStatus !== _constants.ITEM_STATUS.SUCCESS;
  })[0];
  if (!firstItemInProgress || !firstItemInProgress.loaded) return 0;
  var metaData = JSON.parse(firstItemInProgress.metaData),
      itemPercent = firstItemInProgress.loadedPercent || 100 * (firstItemInProgress.loaded / metaData.size);
  return parseInt(itemPercent.toFixed(0), 10);
}